import styled from "styled-components";
// import CompSearchSec from "./Home/CompSearchSec";
import CompSearchBar from "../components/UserDashboardComponents/CompSearchBar";
import { Link } from "react-router-dom";
import LogoCarousel from "../components/LogoCarousel";
// import TestimonialsSlider from "../components/TestimonialsSlider";
import SectionTitle from "../components/SectionTitle";
import FAQSection from "../components/FAQSection";

const HomePage = () => {
  return (
    <Wrapper>
      <div className="container">
        <MainTitle>Supply Chain</MainTitle>
        <SubText>
          Supply chains are critical for business competitiveness, customer satisfaction, and adapting to market dynamics. Nutrify Today invites you to join our platform and start exploring new business possibilities. Connect with potential buyers or suppliers, enhance your market presence, and drive growth.
        </SubText>

        <div className="d-flex justify-content-center align-items-center">
          <Link to='/contact-us' className="mx-auto">
            <Button className="ConnectBtn">Connect With Us</Button>
          </Link>
        </div>
      
        {/* Clients Logos Carousel */}
        <div className="my-md-5 my-3">
          <SectionTitle title="Our Partners" />
          <LogoCarousel />
        </div>
      </div>
      <div>

        {/* <CompSearchSec /> */}
        <div className="pb_75">
          {/* <SectionTitle className="mb-4">Companies & Vendor Services/Products</SectionTitle> */}
          <SectionTitle title="Companies & Vendor Services/Products" />
          <CompSearchBar defaultFetch={true} />
        </div>
      </div>

      {/* Testimonials Carousel Section */}
      {/* <TestimonialsSlider /> */}

      {/* FAQs seciton */}
      <FAQSection />
    </Wrapper>
  );
};

export default HomePage;


const Wrapper = styled.div`
  min-height: 100vh;
  .ConnectBtn{
    background: linear-gradient( 155deg, var(--primary-color) 0%, var(--secondary-color) 100% );
    color: var(--white-color);
    border: 1px solid transparent;
    font-weight: 400;
    font-size: 1rem;
    &:hover { 
      background: white;
      border: 1px solid var(--primary-color);
      color: var(--primary-color); 
    }
  }
`;

// const SectionTitle = styled.h2`
//   text-align: center;
//   color: var(--primary-color);
//   font-size: 1.8rem;
//   font-weight: medium;
//   position: relative;
//   &:before,
//   &:after {
//     content: "";
//     display: inline-block;
//     width: 120px;
//     height: 2px;
//     background: var(--secondary-color);
//     vertical-align: middle;
//     margin: 0 15px;
//   }
// `;

const Button = styled.button`
  padding: 8px 24px;
  border-radius: 50px;
  border: none;
  font-weight: 400;
  margin-left: 12px;
  border: var(--primaryLight-color);
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: {linear-gradient(225deg, var(--primaryLight-color) 0%, var(--secondaryLight-color) 100%)}
  }
`;

const MainTitle = styled.h1`
  text-align: center;
  margin: 80px 0 20px 0;
  font-size: 2.8rem;
  color: var(--primary-color);
  font-weight: 600;
`;

const SubText = styled.p`
  text-align: center;
  max-width: 1050px;
  margin: 0 auto 28px auto;
  color: var(--text-color);
  font-size: 16px;
`;


